import firstBatch from './firstBatch'
export default {
  components: { firstBatch },
  data() {
    return {
      firstBatchVisible: false
    }
  },
  methods: {
    showfirstBatch(row) {
      this.rowData = row;
      this.firstBatchVisible = true;
    }
  }
}